<template>
  <div>
    <CDataTable
        :table-filter="{label:''}"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="item"
        :fields="fields"
        :items-per-page="small ? 50 : 20"
        :dark="dark"
        pagination
    >

      <template #index="{item,index}">
        <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
      </template>

      <template #status="{item,index}">
        <td class="text-left" @click="toggleDetails(item, index)">
          <span
            class="font-weight-bold"
            :class="getStatusColor(item)"
          >
            {{ getStatusValue(item) }}
          </span>
          {{ getStatusPersonText(item) }}
          <br>
          <span
            class="font-weight-bold"
            :class="getStatusColor(item)"
          >
            {{ $t('LatestTime') }} :
          </span>
          {{ elapsedTime(getStatusTime(item)) }}
        </td>
<!--        <td class="text-left"  @click="toggleDetails(item, index)"> {{item.status.filter(obj => { return (obj.key == lang) })[0].value}} <samp v-if="item.status.filter(obj => { return (obj.key === lang) }).at(-1)._id.toString() !== '654851a37ab25be71bbeeed7'">: {{ item.assessor }} </samp> </td>-->
      </template>

      <template #position="{item,index}">
        <td class="text-left"  @click="toggleDetails(item, index)"> {{ getPositionValue(item) }}</td>
      </template>




      <template #action="{item,index}">
        <td style="width: 140px">
          <CRow>
            <CCol class="text-center">
<!--              <CButton  v-if="item.status.filter(obj => { return (obj.key === lang) }).at(-1)._id.toString() === '654851a37ab25be71bbeeed7'" class="mr-1 "  size="sm" color="info" shape="pill" variant="outline" @click="onAssessmentIDP(item, index)"  >-->
<!--                <CIcon name="cil-clipboard"/>-->
<!--              </CButton>-->

              <CButton :disabled="!item.disable" class="mr-1 "  size="sm" color="info" shape="pill" variant="outline" @click="onAssessment(item, index)"  >
                <CIcon name="cil-description"/>
              </CButton>


              <CButton class="mr-1"  size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                <CIcon :name="(item._toggled === true)?'cil-chevron-bottom':'cil-chevron-right'"/>
              </CButton>


            </CCol>
          </CRow>
        </td>
      </template>



      <template #details="{item}">
        <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
<!--          {{ onCheckLevel(item.value.positions)}} -->
<!--          {{ onCheckLevel(item.value.accounts.positions)}}-->
<!--          :year="item.year"-->
          <EDCompetency  :default-datasets="objs.datasets" :points="objs.points" v-for="(objs, idx) in item.value.item" :key="objs.id || idx" :item="objs" :levels="onCheckLevel(item.value.accounts.positions)"/>
        </CCollapse>
      </template>


    </CDataTable>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import EDCompetency from "@/projects/views/E-Performances/Dashboard/users/components/EDCompetency";

export default {
  name: 'History',
  components: {EDCompetency},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },
    item:{
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          // {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"avata", label:"", _style: 'width:50px; text-align: center'},
          {key:"members", label:"Member",  _style: 'width:200px;'},
          {key:"calss", label:"Class Info",},
          {key:"dateTime", label:"Last Update",  _style: 'width:190px;'},
          // {key:"action", label: "#"}
          // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  data: function () {
    return {

      collapseDuration: 0,
      isDialog: false,




    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    onAssessmentIDP (item,index) {
      item.isIDP = true;
      this.$emit('info',item)
    },

    onAssessment (item,index) {
      item.isIDP = false;
      this.$emit('info',item)
    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    onSetLevel(item){
      return 4
    },
    onCheckLastFields(item){
      return item[item.length-1]
    },
    onCheckLevel(data) {

      var level = 1;
      var objs = this.onCheckLastFields(data)
      if(objs.type && objs.type.control != null){
        const start = moment(objs.startDate);
        const end =  moment().set("month",8).set("date",30).add(-2,"year"); // หากไม่มี endDate ให้ใช้วันที่ปัจจุบัน


        const years = end.diff(start, 'years');
        level = objs.type.control.filter((item) => { return (item.year >= years) })[0].level

      }

      if(objs.work && objs.work.control != null){
        level= objs.work.control[objs.work.control.length-1].level;
      }

      if(objs.name && objs.name.control != null){
        level = objs.name.control[objs.name.control.length-1].level;
      }

      return level;
    },

    getStatusByLang(item) {
      if (!item.status || !Array.isArray(item.status)) return null
      return item.status.find(s => s.key === this.lang) || null
    },

    getStatusValue(item) {
      const status = this.getStatusByLang(item)
      return status ? status.value : '-'
    },

    getPositionValue(item) {
      return this.resolveLocalizedValue((item || {}).position) || '-'
    },

    getStatusState(item) {
      const status = this.getStatusByLang(item)
      return {
        _id: (item || {}).statusId || (status && status._id ? status._id : this.getMatchedStatusEntry(item)?.state?._id)
      }
    },

    getStatusColor(item) {
      const statusText = `${this.getStatusValue(item)}`.trim().toLowerCase()

      if (
        statusText === 'pending' ||
        statusText === 'รอดำเนินการ' ||
        statusText === 'รอประเมิน'
      ) {
        return ''
      }

      return this.isColor(this.getStatusState(item))
    },

    getStatusPersonText(item) {
      if (!this.showAssessor(item)) {
        return ''
      }

      return item.assessor ? ` : ${item.assessor}` : ''
    },

    showAssessor(item) {
      const statusId = (this.getStatusState(item)._id || '').toString()
      const statusText = `${this.getStatusValue(item)}`.trim().toLowerCase()

      if (!statusId) {
        return Boolean(item.assessor) && statusText !== 'completed' && statusText !== 'เสร็จสิ้น'
      }

      return statusId !== '654851a37ab25be71bbeeed7'
    },

    getStatusEntries(item) {
      const value = item && item.value ? item.value : {}
      const structure = Array.isArray(value.structure) ? value.structure : []
      const firstStructure = structure[0] || {}

      return [
        ...(Array.isArray(value.status) ? value.status : []),
        ...(Array.isArray(firstStructure.status) ? firstStructure.status : []),
        ...(
          firstStructure.children && Array.isArray(firstStructure.children.status)
            ? firstStructure.children.status
            : []
        )
      ]
    },

    getMatchedStatusEntry(item) {
      const status = this.getStatusByLang(item)
      const statusId = status && status._id ? status._id.toString() : ''
      const statusValue = this.getStatusValue(item)
      const entries = this.getStatusEntries(item)

      return entries
        .slice()
        .reverse()
        .find((entry) => {
          const state = (entry || {}).state || {}
          const stateId = state._id ? state._id.toString() : ''

          return (
            (statusId && stateId === statusId) ||
            (!statusId && this.resolveStateText(state) === statusValue)
          )
        }) || entries.slice().reverse().find((entry) => (entry || {}).timeStamp)
    },

    getStatusTime(item) {
      const matchedStatus = this.getMatchedStatusEntry(item)
      return (
        (item || {}).statusTime ||
        (matchedStatus || {}).timeStamp ||
        (matchedStatus || {}).updatedAt ||
        (item || {}).dateTime ||
        null
      )
    },

    resolveLocalizedValue(items) {
      if (!Array.isArray(items) || items.length === 0) {
        return ''
      }

      return (
        (items.find((entry) => entry && entry.key === this.lang) || {}).value ||
        (items[0] || {}).value ||
        ''
      )
    },

    resolveStateText(state) {
      if (!state) {
        return '-'
      }

      if (Array.isArray(state.title)) {
        return this.resolveLocalizedValue(state.title) || '-'
      }

      return state.value || state.title || '-'
    },

    elapsedTime(dateTime) {
      if (!dateTime) {
        return '-'
      }

      const past = moment(dateTime)

      if (!past.isValid()) {
        return '-'
      }

      const duration = moment.duration(moment().diff(past))
      const minutes = duration.asMinutes()
      const hours = duration.asHours()

      if (minutes < 1) {
        return this.lang === 'th' ? 'เมื่อสักครู่นี้' : 'Just now'
      } else if (minutes < 60) {
        return `${Math.floor(minutes)} ${this.lang === 'th' ? 'นาทีที่แล้ว' : 'm ago'}`
      } else if (hours < 24) {
        const h = Math.floor(hours)
        const m = Math.floor(minutes % 60)
        return `${h} ${this.lang === 'th' ? 'ชั่วโมง' : 'h'} ${m} ${this.lang === 'th' ? 'นาทีที่แล้ว' : 'm ago'}`
      }

      return past.format('DD/MM/YYYY HH:mm')
    },

    isColor(item) {
      const stateId = item && item._id ? item._id.toString() : ''
      const stateMap = {
        '654851a37ab25be71bbeeed7': 'text-success',
        '654851dbe41b7f46025977f6': 'text-warning',
        '654851ece41b7f46025977fa': 'text-info',
        '670f777373effdb76e17954d': '',
        '6723709ab9a2030e40d1b884': 'text-danger',
        '67bc20d5ef3c015b73cf6dbc': 'text-warning',
        '67bc35d9ac0179614e274a67': 'text-warning',
        '67bfc7e724e13ba338b58e47': 'text-info',
        '67bfc7ed24e13ba338b58e4d': 'text-success'
      }

      return stateMap[stateId] || ''
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
